var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2020_2268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2020_2268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.625 6.4L10.425 2.775C10.625 2.50833 10.8625 2.3125 11.1375 2.1875C11.4125 2.0625 11.7 2 12 2C12.3 2 12.5875 2.0625 12.8625 2.1875C13.1375 2.3125 13.375 2.50833 13.575 2.775L16.375 6.4L20.625 7.825C21.0583 7.95833 21.4 8.20417 21.65 8.5625C21.9 8.92083 22.025 9.31667 22.025 9.75C22.025 9.95 21.9958 10.15 21.9375 10.35C21.8792 10.55 21.7833 10.7417 21.65 10.925L18.9 14.825L19 18.925C19.0167 19.5083 18.825 20 18.425 20.4C18.025 20.8 17.5583 21 17.025 21C16.9917 21 16.8083 20.975 16.475 20.925L12 19.675L7.525 20.925C7.44167 20.9583 7.35 20.9792 7.25 20.9875C7.15 20.9958 7.05833 21 6.975 21C6.44167 21 5.975 20.8 5.575 20.4C5.175 20 4.98333 19.5083 5 18.925L5.1 14.8L2.375 10.925C2.24167 10.7417 2.14583 10.55 2.0875 10.35C2.02917 10.15 2 9.95 2 9.75C2 9.33333 2.12083 8.94583 2.3625 8.5875C2.60417 8.22917 2.94167 7.975 3.375 7.825L7.625 6.4ZM8.85 8.125L4 9.725L7.1 14.2L7 18.975L12 17.6L17 19L16.9 14.2L20 9.775L15.15 8.125L12 4L8.85 8.125Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidStar);
export default __webpack_public_path__ + "static/media/kid_star.286352b13ab34016f1ed80a0068f97e7.svg";
export { ForwardRef as ReactComponent };